<template>
  <div class="top-bg">
    <img class="head" src="../../static/logo_4.png" alt="" />
    <div class="index-con">
      <div class="header">
        <div class="header-left">
          <img style="margin-right: 10px" class="header-logo" src="../../static/jiang.png" height="120px" />
          <div class="header-con">
            <!-- <img :src="$t('headerImg')" alt="" /> -->
            <p>{{ $t("headerTitle") }}</p>
            <span class="smiletitle">{{ $t("headerTitle1") }}</span>
          </div>
        </div>
        <img class="earth" src="../../static/logo_3.png" alt="" />
        <div class="header-lan">
          <!-- <span @click="changeLang('zh')"> 中文简体 </span>
          <b>|</b> -->
          <!-- <span @click="changeLang('en')"> English </span> -->
        </div>
      </div>
    </div>
    <div class="navbg">
      <div class="nav">
        <div class="nav-lists-pc" v-for="(item, index) in $t('navList')" :key="index">
          <div class="nav-list-pc" :class="current == '/travel' ||
            current == '/visa' ||
            current == '/traveltwo' ||
            current == '/hotel'
            ? 'active'
            : ''
            " v-if="item.children">
            <p @click.stop="toOther(item.url, item)">{{ item.text }}</p>
            <div class="nav-list-children" v-if="item.show">
              <p :class="current == itm.url ? 'active' : ''" @click.stop="toOther(itm.url)"
                v-for="(itm, ind) in item.children" :key="ind">
                {{ itm.text }}
              </p>
            </div>
          </div>
          <div v-else @click.stop="toOther(item.url, item)" :class="current == item.url ? 'active' : ''"
            class="nav-list-pc">
            {{ item.text }}
          </div>
          <div v-if="index != navList.length - 1" class="line"></div>
        </div>
      </div>
    </div>
    <div class="h5-menu">
      <i class="el-icon-s-unfold" @click.stop="h5show = true"></i>
      <div class="h5-nav" v-if="h5show" @click.stop="h5show = true">
        <p class="h5-title" @click.stop="h5show = false">
          <i class="el-icon-close"></i>
        </p>
        <div v-for="(item, index) in $t('navList')" :key="index + 'a'">
          <div v-if="item.children && item.children.length > 0">
            <p :key="ind" v-for="(itm, ind) in item.children" :class="current == itm.url ? 'active' : ''"
              @click.stop="toOther(itm.url)">
              <b>·</b> {{ itm.text }}
            </p>
          </div>
          <p v-else :class="current == item.url ? 'active' : ''" @click.stop="toOther(item.url), item">
            {{ item.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      twoShow: false,
      h5show: false,
      current: "/",
      navList: [
        {
          text: "Home",
          url: "/",
        },
        {
          text: "Organizer",
          url: "/organizing",
        },
        {
          text: "Committee",
          url: "/committee",
        },
        // {
        //   text: "Call for Papers",
        //   url: "/callPapers",
        // },
        {
          text: "Keynotes",
          url: "/session",
        },
        {
          text: "Program",
          url: "/program",
        },
        {
          text: "Submissions",
          url: "/submissions",
        },
        {
          text: "Registration",
          url: "/reg",
        },
        {
          text: "For Attendees",
          url: "sb",
          children: [
            {
              text: "Visa",
              url: "/visa",
            },
            {
              text: "Venue",
              url: "/travel",
            },
            {
              text: "Travel",
              url: "/traveltwo",
            },
            {
              text: "Hotel",
              url: "/hotel",
            },
          ],
        },
        {
          text: "Sponsors",
          url: "/sponsors",
        },
        {
          text: "Awards",
          url: "/awards",
        },
      ],
    };
  },
  watch: {
    $route: "routerChange",
  },
  mounted() {
    this.routerChange();
    var lang = window.localStorage.getItem("language");
    this.$i18n.locale = lang;
  },
  methods: {
    changeLang(con) {
      window.localStorage.setItem("language", con);
      this.$i18n.locale = con;
    },
    routerChange() {
      this.current = this.$route.path;
    },
    toOther(con, item) {
      this.h5show = false;
      this.twoShow = false;

      this.$t('navList').forEach((itm) => {
        itm.show = false;
      })
      if (item && item.children && item.children.length > 0) {
        item.show = true
        return
      }

      if (con == "/hotel") {
        if (this.$t("travelText6") == "zh") {
          window.open(
            "https://wx.huieke.cn/expo/hotel/listing?eventid=1667315817&orgid=1675422796&lang=zh-cn",
            "_blank"
          );
        } else {
          window.open(
            "https://wx.huieke.cn/expo/hotel/listing?eventid=1667315817&orgid=1675422796&lang=en",
            "_blank"
          );
        }
      } else {
        if (con && this.current != con) {
          this.$router.push(con);
        }
      }
    },
  },
};
</script>

<style scoped>
.head {
  position: absolute;
  right: 0;
  height: 160px;
  top: 0;
}

.top-bg {
  position: relative;
  background-image: url("../../static/top-bg.png");
  background-size: 100% auto;
  background-position: center top;
  min-height: 160px;
  background-repeat: no-repeat;
  background-color: #8fd4c5;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
}

.index {
  width: 100%;
}

.header {
  height: 160px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  position: relative;
  justify-content: space-between;
}

.earth {
  width: 100px;
  height: 100px;
  margin-left: 50px;
  flex-shrink: 0;
}

.header-logo {
  height: 120px;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-con {
  margin-left: 50px;
  height: 120px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.header-con img {
  height: 120px;
}

.header-con p {
  font-size: 30px;
  color: #fff;
  text-shadow: 2px 2px 2px #666;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}

.smiletitle {
  font-size: 24px;
  color: #fff;
  text-shadow: 2px 2px 2px #666;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}

.header-title {
  font-size: 32px;
  font-weight: 600;
  font-family: "LiSu";
  text-shadow: 2px 2px 2px #999;
  margin-bottom: 7px;
  color: #fff;
  font-style: italic;
}

.header-text-con {
  display: flex;
  justify-content: space-between;
}

.header-text {
  font-size: 24px;
  color: #fff;
  margin-top: 10px;
  text-shadow: 2px 2px 2px #999;
  font-family: "Hiragino Sans GB";
}

.header-lan {
  cursor: pointer;
  position: relative;
  z-index: 9999;
  white-space: nowrap;
}

.header-lan b {
  margin: 0 10px;
  font-weight: 400;
}

.navbg {
  width: 100%;
  /* position: fixed;
  top: 0;
  left: 0; */
  z-index: 99999;
  height: 50px;
  background-color: #0a9a7a;
  display: flex;
  justify-content: center;
}

.organizing-bg {
  width: 100%;
  height: 50px;
  border-top: 10px solid #0a9a7a;
  display: flex;
  justify-content: center;
  background: #fff;
}

.nav {
  color: rgba(255, 255, 255, 0.7);
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  width: 1200px;
  display: flex;
  justify-content: space-between;
}

.nav-list-pc {
  font-size: 16px;
  font-weight: 600;
  padding: 0 16px;
  flex: 1;
  text-align: center;
  position: relative;
  z-index: 99999;
}

.nav-list-children {
  position: absolute;
  top: 100%;
  /* right: 10px; */
  /* left: 10px; */
  padding: 0 5px;
  box-sizing: border-box;
  max-width: 160%;
  left: 0;
  text-align: center;
  background: #0a9a7a;
}

.nav-list-children p {
  cursor: pointer;
  white-space: wrap;
  border-top: 1px solid #fff;
  line-height: 1.6;
  padding: 10px 0;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-list-children p:hover,
.nav-list-children .active {
  background: #047229;
  transition: 0.3s all;
}

.line {
  width: 1px;
  height: 20px;
  background: #fff;
  flex-shrink: 0;
}

.nav .active {
  color: #fff;
}

.organizing-bg .nav {
  color: #047229;
}

.nav-list-pc.active,
.nav-list-pc:hover {
  background: #047229;
  transition: 0.3s all;
}

.nav .nav-lists-pc {
  position: relative;
  box-sizing: border-box;
  line-height: 50px;
  display: flex;
  align-items: center;
  flex: 1;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s all;
  font-weight: 600;
  white-space: nowrap;
}

.nav span::after {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.7);
  content: "";
}

.nav span:nth-of-type(1)::after {
  content: none;
}

.nav span:hover {
  background: #047229;
}

.organizing-bg span:hover {
  color: #04551f;
  background: #8fd4c5;
}

.organizing-bg span::after {
  content: none;
}

.h5-menu {
  text-align: right;
  padding: 15px;
  box-sizing: border-box;
  display: none;
  position: relative;
}

.el-icon-s-unfold {
  font-size: 24px;
  color: #0a9a7a;
}

@media screen and (max-width: 768px) {
  .earth {
    display: none;
  }

  .index-con {
    width: 100%;
  }

  .top-bg {
    min-height: 40px;
    height: 180px;
    background-image: url("../../static/top-bg.png");
    background-size: auto 100%;
    background-position: right top;
  }

  .header-con {
    margin-left: 10px;
    position: absolute;
    top: 0;
    left: 0;
    text-indent: 80px;
  }

  .header-con img {
    height: 80px;
  }

  .header {
    display: block;
    position: relative;
    margin-top: 50px;
    height: auto;
    padding: 10px 10px 20px;
    box-sizing: border-box;
  }

  .header-logo {
    height: 60px;
  }

  .footer-right img {
    width: 100%;
    height: auto;
  }

  .header-title {
    font-size: 16px;
  }

  .header-text {
    font-size: 13px;
  }

  .header-lan {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .header-left {
    position: relative;
    display: block;
  }

  .navbg,
  .organizing-bg {
    display: none;
  }

  .h5-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 50px;
    display: block;
    background: #8fd4c5;
    z-index: 1001;
  }

  .h5-nav {
    position: absolute;
    background: #fff;
    z-index: 999;
    top: 100%;
    border: 1px solid #ddd;
    box-shadow: 3px 3px 4px #ddd;
    right: 10px;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
  }

  .h5-menu .el-icon-close {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 24px;
  }

  .h5-title {
    text-align: right;
    border-bottom: 0;
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .h5-nav p {
    height: 36px;
    display: flex;
    border-bottom: 1px dashed #eee;
    align-items: center;
  }

  .h5-nav p.active {
    color: #04551f;
    font-weight: 600;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue